
export const setLanguage = (language) => {
    return {
        type: "SET_LANGUAGE",
        payload: language
    }
};


// WEBPACK FOOTER //
// ./src/store/actions/i18n.js